<!-- <header class="navpage-header"  role="banner" style="background-color:#1d1d1d"> -->
<div class="navbar navbar-default navpage-header" style="margin-left: 100px;padding-top: 18px">
  <div class="container-fluid">
    <div class="navbar-header" nav-banner-logo="">
      <a class="navbar-brand" [routerLink]="['/dashboard']">
        <img class="banner-text" style="height: 32px; margin-top:-22px;margin-left:-30px"
          src="assets/img/EY_Logo.png" />
      </a>
      <span>IN Help Desk</span>
    </div>

    <div class="nav navbar-right">
      <div class="navpage-pickers navpage-header-content hidden-xs hidden-sm hidden-md"></div>


      <div class="navbar-custom-menu hidden-xs" style="margin-right:10%">
        <ul class="nav navbar-nav">
          <!-- Messages: style can be found in dropdown.less-->

          <!-- User Account Menu -->
          <li class="dropdown user user-menu">
            <!-- Menu Toggle Button -->

            <a [matMenuTriggerFor]="menu" style="color: white;text-decoration: none;cursor:pointer;">
              <!-- The user image in the navbar-->
              <!-- <img src="assets/img/user2-160x160.jpg" class="user-image" alt="User Image"> -->
              <img src="assets/img/defaultImage.jpg" class="user-image" alt="User Image">
              <!-- hidden-xs hides the username on small devices so only the image appears. -->
              <!-- <span class="hidden-xs">Amrata Khare</span> -->
              {{userDetails.EmpName}}
            </a>
            <mat-menu #menu="matMenu">
              <ul class="nav navbar-nav">

                <li class="user-footer">
                  <div class="pull-left">
                    <a id="bookmarkme" href="javascript:createBookmark()" class="btn btn-default btn-flat"
                      title="bookmark this page">Add to favourite</a>
                  </div>
                  <div class="pull-right">
                    <a class="btn btn-default btn-flat" (click)="logoutUser()">Sign out</a>
                  </div>
                </li>

              </ul>
            </mat-menu>

          </li>
        </ul>
      </div>

    </div>
  </div>
</div>

<div class="navbar-divider" style="background-color: #5a7f71;height: 4px;"></div>
<!-- </header> -->